import Image from "next/image";
import React, { FC } from "react";

interface DoubleSectionProps {}

const DoubleSection: FC<DoubleSectionProps> = () => {
  return (
    <div>
      <div className="mx-4 sm:mx-16 xl:mx-40 2xl:mx-96 pb-8  lg:pt-16  ">
        <div className="flex flex-col-reverse lg:flex-row">
          <div className="lg:w-1/2  ">
            <div className=" lg:w-11/12 xl:w-10/12 2xl:w-11/12 text-center lg:text-left -mt-16 sm:-mt-0">
              <div className="w-11/12  mx-auto lg:ml-0 ">
                <p className="text-xl  sm:text-4xl  2xl:text-5xl font-semibold future-letter-spacing2 future-text-black leading-snug xl:future-line-height mt-8 sm:mt-12">
                  Get leverage. Amplify your profits or losses.
                </p>
                <p className="text-sm  sm:text-2xl tracking-wide sm:font-thin future-text-gray mt-4 sm:mt-8 leading-snug future-letter-spacing3 sm:future-letter-spacing2">
                  GetFuture provides you a leveraged wallet meaning, you can
                  gain exposure to higher yields than you’d normally get if you
                  just hold bitcoin. e.g. At 2x leverage, your profits &amp;
                  loss are doubled.
                </p>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 ">
            <div className="flex justify-center lg:justify-end w-full mb-8 sm:mb-0 pt-16 lg:pt-0">
              <div className="relative overflow-y-hidden h-64 w-64 sm:h-[30rem] sm:w-[40rem] -mt-24">
                <Image src="/illustrations/leverage.svg" layout="fill" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleSection;
